<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator" :md="24" :sm="24" style="margin: 0 0px 10px 2px">
      <a-button :readOnly="currentDept.orgCategory != 3" @click="handleAddCourse" type="primary" icon="plus"
        >关联课程</a-button
      >

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"> <a-icon type="delete" />删除 </a-menu-item>
          <a-menu-item v-if="currentDept.orgType == '1' || currentDept.orgType == '2'" key="2" @click="handleShowClone(false)">
            <a-icon type="apartment" />分配
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600"> {{ selectedRowKeys.length }} </a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEditCourseSchedule(record)">排课</a>

          <span v-if="currentDept.orgType == '1' || currentDept.orgType == '2'">
            <a-divider type="vertical" />
            <a @click="handleShowClone(record.id)">分配</a>
          </span>

          <a-divider type="vertical" />
          <a-popconfirm title="确定要将本课程移除班级吗?" @confirm="() => handleDelete(record.id)">
            <a>移除</a>
          </a-popconfirm>

          <a-divider type="vertical" />
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <teachingCourseSchedule-modal ref="editCourseSchedule" @ok="modalFormOk" />
    <T-Select-Course-Modal ref="selectCourseModal" @ok="handleOk" />
    <a-modal :visible="showCloneModal" title="分配课程" @ok="batchClone" @cancel="showCloneModal=false">
      <p>将课程分配至下级部门，开课方式和开课时间将继承设置</p>
      <br />
      是否同时复制课程单元的排课信息？
      <a-switch v-model="alsoCopySchedule">
        <a-icon slot="checkedChildren" type="check" />
        <a-icon slot="unCheckedChildren" type="close" />
      </a-switch>
    </a-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction, deleteAction } from '@/api/manage'
import TSelectCourseModal from './selector/TSelectCourseModal'
import TeachingCourseScheduleModal from './TeachingCourseScheduleModal'

export default {
  name: 'DeptCourseInfo',
  mixins: [JeecgListMixin],
  components: {
    TSelectCourseModal,
    TeachingCourseScheduleModal,
  },
  data() {
    return {
      showCloneModal: false,
      alsoCopySchedule: true,
      copyCourseIds: '',
      description: '课程信息',
      currentDeptId: '',
      currentDept: {},
      // 表头
      columns: [
        {
          title: '课程ID',
          align: 'center',
          dataIndex: 'courseId',
        },
        {
          title: '课程名',
          align: 'center',
          dataIndex: 'courseName',
        },
        {
          title: '开课时间',
          align: 'center',
          dataIndex: 'openTime',
          customRender(v, r) {
            if (r.openMethod == 1) {
              return '手动'
            }else if(r.openMethod == 0){
              return '关闭'
            }else if(r.openMethod == 2){
              return '定时'
            } else {
              return v
            }
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 120,
        },
      ],
      isorter: {
        column: 'teachingCourseDept.createTime',
        order: 'desc',
      },
      url: {
        list: '/teaching/teachingCourseDept/list',
        add: '/teaching/teachingCourseDept/add',
        addOrUpdate: '/teaching/teachingCourseDept/addOrUpdate',
        edit: '/teaching/teachingCourseDept/edit',
        delete: '/teaching/teachingCourseDept/delete',
        deleteBatch: '/teaching/teachingCourseDept/deleteBatch',
        cloneBatch: '/teaching/teachingCourseDept/cloneBatch',
      },
    }
  },
  created() {},

  methods: {
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      if (this.currentDeptId === '') return
      var params = this.getQueryParams() //查询条件
      params.deptId = this.currentDeptId
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
      })
    },
    handleShowClone(id) {
      this.showCloneModal = true
      if (id) {
        this.selectedRowKeys = [id]
      }
    },
    // cloneToSubDept(id) {
    //   var that = this
    //   getAction(that.url.cloneBatch, { ids: id, copySchedule: this.alsoCopySchedule }).then((res) => {
    //     if (res.success) {
    //       that.$message.success(res.message)
    //       that.loadData()
    //       that.onClearSelected()
    //     } else {
    //       that.$message.warning(res.message)
    //     }
    //   })
    // },
    batchClone() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        console.log(this.currentDeptId)
        getAction(that.url.cloneBatch, { ids: ids, departId: this.currentDeptId, copySchedule: this.alsoCopySchedule }).then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.loadData()
            that.onClearSelected()
          } else {
            that.$message.warning(res.message)
          }
          that.showCloneModal = false
        })
      }
    },
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        var that = this
        console.log(this.currentDeptId)
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中课程和排课信息?',
          onOk: function () {
            deleteAction(that.url.deleteBatch, { ids: ids }).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          },
        })
      }
    },
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete, { id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          if (this.selectedRowKeys.length > 0) {
            for (let i = 0; i < this.selectedRowKeys.length; i++) {
              if (this.selectedRowKeys[i] == id) {
                this.selectedRowKeys.splice(i, 1)
                break
              }
            }
          }
          that.loadData()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    open(record) {
      console.log(record)
      this.currentDept = record
      this.currentDeptId = record.id
      this.loadData(1)
    },
    clearList() {
      this.currentDeptId = ''
      this.dataSource = []
    },
    hasSelectDept() {
      if (this.currentDeptId == null) {
        this.$message.error('请选择一个部门!')
        return false
      }
      return true
    },
    //添加课程
    handleAddCourse() {
      if (this.currentDeptId == '') {
        this.$message.error('请选择一个部门!')
      } else {
        this.$refs.selectCourseModal.show(this.currentDeptId)
      }
    },
    //排课
    handleEditCourseSchedule(record) {
      this.$refs.editCourseSchedule.edit(record)
      this.$refs.editCourseSchedule.title = '排课'
      this.$refs.editCourseSchedule.disableSubmit = false
    },
    handleOk(rows, keys) {
      let params = {}
      params.deptId = this.currentDeptId
      params.resIdList = []
      for (var a = 0; a < rows.length; a++) {
        params.resIdList.push(rows[a].id)
      }
      console.log(params)
      postAction(this.url.addOrUpdate, params).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 3px;
}

.ant-card {
  margin-left: -30px;
  margin-right: -30px;
}

.table-page-search-wrapper {
  margin-top: -16px;
  margin-bottom: 16px;
}
</style>